import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function FalkeCoinLogo({ size = 56, className = "", glow = false, animate = false }) {
  return (
    <img
      src="/falkecoin-logo.png"
      alt="FalkeCoin"
      width={size}
      height={size}
      data-testid="falke-coin-logo"
      className={`${className} ${glow ? "coin-glow" : ""} ${animate ? "coin-spin-once" : ""} inline-block select-none`}
      draggable={false}
      style={{ borderRadius: "50%" }}
    />
  );
}

function _logoDestination(user) {
  if (!user) return "/login";
  if (user.role === "admin" || user.role === "buchhalter") return "/admin";
  if (user.role === "vertriebler") return "/vertriebler";
  if (user.tippgeber_modus === "gewerblich_aktiv") return "/app/tippgeber";
  return "/app";
}

export function FalkeTekLogo({ height = 38, className = "", showSlogan = true }) {
  // useAuth ist außerhalb des Providers (z. B. Login/Register-Seite) optional;
  // dort nutzt useContext einfach null, daher kein Throw.
  const auth = useAuth();
  const to = _logoDestination(auth?.user);
  return (
    <Link
      to={to}
      className={`flex items-center gap-3 ${className} hover:opacity-90 transition`}
      data-testid="falke-tek-logo"
      aria-label="FalkeTek Startseite"
    >
      <img
        src="/falke-tek-logo.svg"
        alt="FalkeTek"
        style={{ height: `${height}px`, width: "auto" }}
        className="object-contain"
      />
      {showSlogan && (
        <div className="hidden sm:flex flex-col leading-tight border-l border-falke-blue/15 pl-3">
          <span className="text-[11px] font-semibold tracking-[0.18em] uppercase text-falke-orange">FalkeCoin</span>
          <span className="text-[11px] text-falke-blue/70 tracking-wide font-medium">Empfehlen. Profitieren. Energie teilen.</span>
        </div>
      )}
    </Link>
  );
}
